import { useContext, useEffect} from "react";

//context
import { ContentAudienceContext } from "./ContentAudienceContext";

//components
import TotalAudience from "./TotalAudience";
import EditAudience from "./EditAudience";
import Information from "../global/Information";
import BasicButton from "../global/buttons/BasicButton/BasicButton";
import ResetAudience from "./ResetAudience";
import ModalWrapper from "@/components/modals/ModalWrapper";
import AudienceModalSearchAndFilter from './ContentAudienceSearchAndFilter';

//icon-library
import { IconLibrary } from "@/interfaces/IconLibrary";
import Icon from "../icons/Icons";

//hook
import useContentAudience from "./ContentAudience.hook";

//interfaces
import { AudienceModalState, AddOrEditModalStateOnly } from "@/interfaces/ContentAudienceModal";

import ContentAudienceViewParents from './ContentAudienceViewParents'



const AudienceModal = ({isOpen, toggleOpen, initalAudienceState}:{isOpen: boolean, toggleOpen: (val: boolean) => void, initalAudienceState: AudienceModalState | undefined}) => {
    
    const {
        audienceModalState,
        setAudienceModalState,
        currentSelection,
        contentTitle,
        filterOptions,
        debouncedSearchTerm,
        sort,
        lastPage,
        currentSelectionChanged,
        filterIsOpen,
        showExistsInMultiplePlaces,
        setCurrentSelectionChanged,
        setCurrentSelection,  
        groupFilters   
    } = useContext(ContentAudienceContext);

    const {table, handlePermissionsReset, updateAudienceResponse } = useContentAudience();

    useEffect(() => {

        if (isOpen) {
            document.body.style.overflow = 'hidden'
        }
        else {
            document.body.style.overflow = 'initial'
        }

        return () => {
            document.body.style.overflow = 'initial'
            setAudienceModalState(undefined);
        }
    }, [isOpen])

    function getTableHeight(): number {
        if(!table.rows.length) {
            return  88
        }

        return table.rows.length >= 9 ? 400 : table.rows.length * 40 + 35
    }

    function getModalHeight() {
        return getTableHeight() + 200 + (filterIsOpen ? 97 : 0) + (showExistsInMultiplePlaces ? 50 : 0)
    }

    function setHeight(){
        const modal: HTMLDivElement = (document.querySelector('.EditAudience') || document.querySelector('.AddAudience')) as HTMLDivElement;

        if(modal) {
            modal.style.height = `${getModalHeight()}px`;
        }
    }

    useEffect(() => {
        setHeight();
    }, [])

    useEffect(() => {
        !audienceModalState && setAudienceModalState(initalAudienceState);
    },[initalAudienceState])

        

    useEffect(() => {
        if(!currentSelectionChanged) {
            updateAudienceResponse(audienceModalState as AddOrEditModalStateOnly, currentSelection)
        }
        else {
            updateAudienceResponse(audienceModalState as AddOrEditModalStateOnly, currentSelection, 'newtab')
            setCurrentSelectionChanged(false)
        }
    }, [filterOptions, debouncedSearchTerm, sort.sort, sort.sortBy, groupFilters])


    function handleClose(){
        toggleOpen(false);
        setAudienceModalState(undefined);
    }

    function getAudienceModalContents(){
        switch(audienceModalState) {
            case AudienceModalState.TotalAudience:
                return  <TotalAudience setAudienceModalState={setAudienceModalState} />;

            case AudienceModalState.EditAudience:
                return  <EditAudience
                            title={`Edit Audience - ${contentTitle}`}
                            EditAudienceUpperControls={<>
                                <Information
                                    text={"Any permission updates will apply to nested content unless they have unique permissions."}
                                    style={{ background: 'transparent'}} 
                                />
                                <div className="edit-audience-header-control-wrapper">
                                    <BasicButton
                                        className={'audience-modal-bb add-users'}
                                        content={'+ Add Group(s)'} 
                                        ariaLabel={'Add Groups'} 
                                        onButtonClick={() => {
                                            setAudienceModalState(AudienceModalState.AddAudience)
                                            setCurrentSelection('Groups')
                                        }}
                                    />
                                    <BasicButton 
                                        className={'audience-modal-bb'}
                                        content={<Icon iconName={IconLibrary.COG} sizeInPx={'12'} />}
                                        ariaLabel={'Manage Audience'}
                                        onButtonClick={() => setAudienceModalState(AudienceModalState.ResetAudience)}
                                    />
                                </div>
                               
                            </>}
                            EditAudienceBottomControls={
                                <BasicButton 
                                    content={'Back'}
                                    ariaLabel={'Back to view audience'}
                                    onButtonClick={() => setAudienceModalState(AudienceModalState.TotalAudience)}
                                />}
                            table={table}
                            SearchAndFilter={<AudienceModalSearchAndFilter />}
                            currentTableSelection={currentSelection}
                            
                        />

            case AudienceModalState.AddAudience:
                return  <EditAudience
                            title={`Add Groups - ${contentTitle}`} 
                            EditAudienceUpperControls={
                                <Information 
                                    text={"Any permission updates will apply to nested content unless they have unique permissions."}
                                    style={{background:'transparent'}}
                                />}
                            table={table}
                            EditAudienceBottomControls={
                                <BasicButton
                                    content={'Back'}
                                    ariaLabel={'Back to edit audience'}
                                    onButtonClick={() => setAudienceModalState(AudienceModalState.EditAudience)}
                                />
                            }
                            SearchAndFilter={<AudienceModalSearchAndFilter isAddGroup/>}
                            currentTableSelection={currentSelection}
                        />

            case AudienceModalState.ResetAudience:
                return  <ResetAudience 
                    contentTitle={contentTitle}
                    setAudienceModalState={setAudienceModalState}
                    onConfirmResetClick={handlePermissionsReset}
                />;

            case AudienceModalState.ViewParents:
                return <ContentAudienceViewParents
                    setAudienceModalState={setAudienceModalState}
                    back={lastPage as AudienceModalState}
                />;

            default:
                <></>;
        }
    }

    return (
        <ModalWrapper className={`full-page-modal ${audienceModalState}`} isOpen={isOpen} onRequestClose={handleClose} isFullPage>
            {getAudienceModalContents()}
        </ModalWrapper>  
    ) 
}

export default AudienceModal